<div class="home-block light" id="galleries">
  <div class="home-container content-center">
    <h1>Galériák</h1>
    <div class="galleryContainer">
      <div class="dome-bg">
        <img
          alt="Dóm Háttér"
          height="266"
          loading="lazy"
          src="/multimedia/home/bg-dome.webp"
          width="750"
        />
      </div>
      <div class="scope">
        @for (gallery of galleries; track $index) {
          <span [style.--i]="$index">
            <button class="gallery home-box" type="button" (click)="openInFullScreen($index)">
              <h2>{{ gallery.year }}</h2>
              <p>SZEBIT</p>
            </button>
          </span>
        }
      </div>
    </div>
  </div>
</div>
